import type { MonetizingRegion } from '@openx/types/monetizing.ts';

export const pacingRegionLabels: Record<MonetizingRegion, string> = {
  ASIA: 'APAC',
  EU: 'EU',
  US: 'NA & LATAM',
};
